var map = {
	"./control.png": 2871,
	"./dental-checkup.png": 261,
	"./docpat.png": 8808,
	"./logo-rose.png": 9360,
	"./logo-trans.png": 9290,
	"./nurse2.png": 6897,
	"./nurse3.png": 6778,
	"./nurse4.png": 5124,
	"./nurse5.png": 9852,
	"./nurse6.png": 3271,
	"./nurse7.png": 4469,
	"./nurse8.png": 3670,
	"./retainer.png": 4267,
	"./x-ray.png": 1406,
	"./yanal-website-mobile.png": 6880,
	"./yanal-website.png": 8705
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9197;